import CloseRounded from "@mui/icons-material/CloseRounded";
import CodeOutlined from "@mui/icons-material/CodeOutlined";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import { grey } from "@mui/material/colors";
import isBoolean from "lodash/isBoolean";
import isFunction from "lodash/isFunction";
import SearchInputLight from "../inputs/SearchInputLight";
import Flx from "../layout/Flx";
import ScreenContent from "../layout/ScreenContent";
import ToggleTabSwitcher from "../navigation/ToggleTabSwitcher";
import Htag from "../typography/Htag";

const TablePreviewCard = ({
  title,
  children,
  onClose,
  icon,
  formSpy,
  setFormSpy,
  quickFilter,
  setQuickFilter,
  titleEndContent,
  searchPlaceholder,
  tab,
  tabs,
  onTabChange,
  bodySx,
  bodyStartContent,
}) => {
  return (
    <CardRoot onClose={onClose}>
      <Header>
        <Flx jb ac>
          <Flx ac gap={2}>
            {title && <Htag sx={{ fontSize: "16px" }}>{title}</Htag>}
            {isFunction(setQuickFilter) ? (
              <SearchInputLight
                fullWidth={false}
                value={quickFilter}
                placeholder={searchPlaceholder}
                onChange={setQuickFilter}
              />
            ) : null}
          </Flx>
          <Flx ac gap={1}>
            {titleEndContent}
            {isBoolean(formSpy) ? (
              <IconButton
                color={formSpy ? "primary" : "default"}
                onClick={() => setFormSpy((s) => !s)}
              >
                <CodeOutlined />
              </IconButton>
            ) : null}

            {isFunction(onClose) ? (
              <IconButton onClick={onClose}>
                <CloseRounded />
              </IconButton>
            ) : null}
          </Flx>
        </Flx>

        {tab && tabs && (
          <ToggleTabSwitcher
            value={tab}
            variant={"underline"}
            onChange={onTabChange}
            tabs={tabs}
          />
        )}
      </Header>
      {/* <Header>
        <Flx fw jb ac>
          <Flx gap={1} ac>
            {icon}
            <Htag>{title}</Htag>
            {titleEndContent}
          </Flx>
          <Flx>
            {isBoolean(formSpy) ? (
              <IconButton
                color={formSpy ? "primary" : "default"}
                onClick={() => setFormSpy((s) => !s)}
              >
                <CodeOutlined />
              </IconButton>
            ) : null}

            {isFunction(onClose) ? (
              <IconButton onClick={onClose}>
                <CloseRounded />
              </IconButton>
            ) : null}
          </Flx>
        </Flx>
        {isFunction(setQuickFilter) ? (
          <SearchInputLight
            fullWidth={false}
            value={quickFilter}
            placeholder={searchPlaceholder}
            onChange={setQuickFilter}
          />
        ) : null}
      </Header> */}
      {bodyStartContent}
      <Body bodySx={bodySx}>{children}</Body>
    </CardRoot>
  );
};

const Header = ({ children }) => {
  return (
    <Flx
      column
      sx={{
        p: 0,
        // display: "flex",
        // justifyContent: "space-between",
        borderBottom: `1px solid ${grey[200]}`,
        pb: 0.5,
      }}
    >
      {children}
    </Flx>
  );
};

const Body = ({ bodySx, children }) => {
  return (
    <ScreenContent
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        ...bodySx,
      }}
    >
      {children}
    </ScreenContent>
  );
};

const CardRoot = ({ children, onClose, fullScreen }) => {
  return (
    <>
      {/* <Backdrop
        open
        onClick={onClose}
        sx={{
          zIndex: 2000,
        }}
      /> */}
      <Card
        sx={{
          // p: 2,
          // m: "0 auto",
          background: "#ffffff",
          borderLeft: `6px solid #eff7fe`,
          flexGrow: 1,
          flexShrink: 1,
          // width: "100%",
          // flexBasis: "780px",
          minHeight: "70vh",
          // maxWidth: "1200px",
        }}
      >
        {children}
      </Card>
    </>
  );
};

export default TablePreviewCard;
// import CloseRounded from "@mui/icons-material/CloseRounded";
// import CodeOutlined from "@mui/icons-material/CodeOutlined";
// import Box from "@mui/material/Box";
// import Card from "@mui/material/Card";
// import Container from "@mui/material/Container";
// import IconButton from "@mui/material/IconButton";
// import { grey } from "@mui/material/colors";
// import isBoolean from "lodash/isBoolean";
// import isFunction from "lodash/isFunction";
// import PropTypes from "prop-types";
// import SearchInputLight from "../inputs/SearchInputLight";
// import Flx from "../layout/Flx";
// import ScreenContent from "../layout/ScreenContent";
// import Htag from "../typography/Htag";

// const TablePreviewCard = ({
//   title,
//   children,
//   onClose,
//   icon,
//   formSpy,
//   setFormSpy,
//   quickFilter,
//   setQuickFilter,
//   titleEndContent,
//   searchPlaceholder,
//   bodySx,
//   bodyStartContent,
// }) => {
//   return (
//     <OuterBackground onClose={onClose}>
//       <PreviewCard>
//         <Header>
//           <Flx fw jb ac>
//             <Flx gap={1} ac>
//               {icon}
//               <Htag>{title}</Htag>
//               {titleEndContent}
//             </Flx>
//             <Flx>
//               {isBoolean(formSpy) ? (
//                 <IconButton
//                   color={formSpy ? "primary" : "default"}
//                   onClick={() => setFormSpy((s) => !s)}
//                 >
//                   <CodeOutlined />
//                 </IconButton>
//               ) : null}

//               {isFunction(onClose) ? (
//                 <IconButton onClick={onClose}>
//                   <CloseRounded />
//                 </IconButton>
//               ) : null}
//             </Flx>
//           </Flx>
//           {isFunction(setQuickFilter) ? (
//             <SearchInputLight
//               fullWidth={false}
//               value={quickFilter}
//               placeholder={searchPlaceholder}
//               onChange={setQuickFilter}
//             />
//           ) : null}
//         </Header>
//         {bodyStartContent}
//         <Body bodySx={bodySx}>{children}</Body>
//       </PreviewCard>
//     </OuterBackground>
//   );
// };

// TablePreviewCard.propTypes = {
//   title: PropTypes.string.isRequired,
//   children: PropTypes.node.isRequired,
//   onClose: PropTypes.func,
//   icon: PropTypes.node,
//   formSpy: PropTypes.bool,
//   setFormSpy: PropTypes.func,
//   quickFilter: PropTypes.string,
//   setQuickFilter: PropTypes.func,
//   searchPlaceholder: PropTypes.string,
//   bodySx: PropTypes.object,
//   bodyStartContent: PropTypes.node,
// };

// const Header = ({ children }) => {
//   return (
//     <ScreenContent
//       sx={{
//         p: 0,
//         borderBottom: `1px solid ${grey[200]}`,
//         pb: 0.5,
//       }}
//     >
//       {children}
//     </ScreenContent>
//   );
// };

// Header.propTypes = {
//   children: PropTypes.node.isRequired,
// };

// const Body = ({ bodySx, children }) => {
//   return (
//     <ScreenContent
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         gap: 3,
//         ...bodySx,
//       }}
//     >
//       {children}
//     </ScreenContent>
//   );
// };

// Body.propTypes = {
//   bodySx: PropTypes.object,
//   children: PropTypes.node.isRequired,
// };

// const PreviewCard = ({ children }) => {
//   return <Box sx={{ maxWidth: "1110px", margin: "0 auto" }}>{children}</Box>;
//   // return <Card>{children}</Card>;
// };

// PreviewCard.propTypes = {
//   children: PropTypes.node.isRequired,
// };

// const OuterBackground = ({ children, onClose, fullScreen }) => {
//   return (
//     <>
//       {/* <Backdrop
//         open
//         onClick={onClose}
//         sx={{
//           zIndex: 2000,
//         }}
//       /> */}
//       <Card
//         sx={{
//           p: 2,
//           m: "0 auto",
//           background: "#ffffff",
//           borderLeft: `6px solid #eff7fe`,
//           flexGrow: 1,
//           flexShrink: 1,
//           // width: "100%",
//           flexBasis: "780px",
//           minHeight: "70vh",
//           maxWidth: "1200px",
//         }}
//       >
//         <ScreenContent suppressPaddingLeftRight>{children}</ScreenContent>
//       </Card>
//     </>
//   );
// };

// OuterBackground.propTypes = {
//   children: PropTypes.node.isRequired,
// };

// export default TablePreviewCard;
